/*
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isStrEmptyOrNull } from '../common/UtilityFunctions';
import { getUserId } from '../storage/userStorage';

// Redirects to login, if userId is blank in userStorage
const NoLoginRedirect = ({ url }) => {
  const navigate = useNavigate();
  const userId = getUserId();

  useEffect(() => {
    isStrEmptyOrNull(userId) ? navigate('/login') : navigate(url);
  }, [userId, navigate, url]);

  return null;
};

export default NoLoginRedirect;
